import React from 'react'
import type { IconDefaultProps } from '../../../models/types'

const HomeIcon = ({ className, color }: IconDefaultProps): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 17.875 17.044'
      className={className || 'rf-w-4 rf-h-4'}
    >
      <path
        d='M13.721,3.5V4.9l1.663,1.33V3.5Zm2.91,3.733V3.289A1.039,1.039,0,0,0,15.592,2.25H13.513a1.039,1.039,0,0,0-1.039,1.039V3.9l-.339-.271a3.118,3.118,0,0,0-3.9,0l-6.756,5.4a.624.624,0,0,0,.779.974l.65-.52v8.555H1.874a.624.624,0,0,0,0,1.247H18.5a.624.624,0,1,0,0-1.247H17.462V9.492l.65.52a.624.624,0,0,0,.779-.974Zm-.416,1.265L11.356,4.607a1.871,1.871,0,0,0-2.337,0L4.16,8.494v9.552H7.07V14.472a11.466,11.466,0,0,1,.051-1.41,1.7,1.7,0,0,1,1.615-1.615,11.468,11.468,0,0,1,1.41-.051h.082a11.469,11.469,0,0,1,1.41.051,1.7,1.7,0,0,1,1.615,1.615,11.451,11.451,0,0,1,.051,1.41v3.574h2.91Zm-4.157,9.552V14.513a10.966,10.966,0,0,0-.04-1.285c-.036-.27-.1-.355-.143-.4s-.132-.106-.4-.143a10.966,10.966,0,0,0-1.285-.04,10.964,10.964,0,0,0-1.285.04c-.27.036-.355.1-.4.143s-.106.132-.143.4a10.957,10.957,0,0,0-.04,1.285v3.533ZM10.187,7.238a1.039,1.039,0,1,0,1.039,1.039A1.039,1.039,0,0,0,10.187,7.238ZM7.9,8.278a2.286,2.286,0,1,1,2.286,2.286A2.286,2.286,0,0,1,7.9,8.278Z'
        transform='translate(-1.25 -2.25)'
        fill={color || "#FFF"}
        fillRule='evenodd'
      />
    </svg>
  )
}

export default HomeIcon
